export default __webpack_public_path__ + "static/media/Close X icon.svg";